<footer class="footer" id="footer">
  <div class="container">
    <a *ngIf="privacyPolicyDocument" [href]="privacyPolicyDocument" target="_blank" rel="noopener">
      Política de privacidade
    </a>
  </div>
</footer>
